(function () {
    'use strict';

    a3_cabin_reports.directive('onestopshopEvent', onestopshopEvent);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name onestopshopEvent
    * @restrict E
    * @description
    *   Implementation of onestopshopEvent
    * @example
    *   Usage:
    *   <onestopshop-event></onestopshop-event>
    * @ngInject
    */
    function onestopshopEvent() {
        function link(scope) {
            scope.ToolkitItem = scope.customerEvent.ToolkitItem;
            scope.Treatment = scope.customerEvent.Treatment;
        }
        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/OneStopShop/onestopshopEvent.tpl.html',
            scope: {customerEvent: "="},
            link: link
        }
    }

})();
